<template>
  <modal wrapperClasses="passcode">
    <div slot="body" class="modal-content">
      <div>a temporary PIN has been sent to your phone</div>
      <div>please enter it below to proceed</div>
      <passcode-input
        :length-limitation="6"
        :passcode.sync="passcode"
        autocomplete="one-time-code" />
      <div v-if="error" class="error">{{ error }}</div>
    </div>
    <div slot="action" class="modal-click-action">
      <button @click="clickedEnter()" class="button submit">enter</button>
    </div>
    <div slot="footer" class="modal-footer">
      <div v-if="!hasBeenSent">didn't get the pin?</div>
      <div @click="clickedResend()" v-if="!hasBeenSent" class="link">resend</div>
      <div v-if="hasBeenSent">thank you for your request. you should receive your temporary pin within a few minutes</div>
    </div>
  </modal>
</template>

<script>
  import Modal from '../../components/shared/Modal'
  import { passcodeAPI } from "../../services/api/passcode"
  import PasscodeInput from '../../components/shared/PasscodeInput'

  export default {
    props: {
      memberAccessCode: Number
    },

    name: 'TemporaryPinCodeModal',

    data() {
      return {
        error: '',
        passcode: '',
        hasBeenSent: false,
      }
    },

    components: {
      Modal,
      PasscodeInput
    },

    computed: {
      encodedSecureLinkId(){
        return this.$route.params.id
      }
    },

    methods: {
      clickedEnter(){
        if(!this.passcode) return this.showInvalidPinErr()
        return  passcodeAPI.getCheckTempPin(
                  this.encodedSecureLinkId,
                  this.passcode
                )
                .then(resp => this.$emit('validTemporaryCode'))
                .catch(error => this.showInvalidPinErr())
      },

      clearError(){
        return this.error = ''
      },

      clickedResend(){
        this.hasBeenSent = true
        // We show the button "resend" after 10 minutes
        window.setTimeout(() => {
          this.hasBeenSent = false
        }, 10 * 60 * 1000)
        return this.sendTemporaryPinCode()
      },

      sendTemporaryPinCode(){
        return passcodeAPI.postSendTempPin(this.encodedSecureLinkId).then(data => this.$emit('update:memberAccessCode', data.id))
      },

      showInvalidPinErr(){
        this.error = 'must enter valid PIN'
      }
    },

    created(){
      this.sendTemporaryPinCode()
    },

    watch: {
      passcode(value){
        this.clearError()
      }
    }
  }
</script>